var OFFSET = OFFSET || {};

OFFSET.debounce = function(fn, delay) {
	let timeoutId;
	return function (...args) {
		clearTimeout(timeoutId); // Clear any existing timeout
		timeoutId = setTimeout(() => { // Set up new timeout
			fn.apply(this, args);
		}, delay);
	};
}

OFFSET.shippingMessage = function() {
	var specialMessageModal = $.cookie("specialmessage");
	if (specialMessageModal == "read") {
		return;
	} else {
		setTimeout(function(){
			$("#figureMessageModal").modal();
		}, 3000);	
	}	
	$("#figureMessageModal").on("hide.bs.modal", function (event) {
		$.cookie("specialmessage", "read", { path: "/" });
	});
	$("#figureMessageModal a").click(function() {
		$.cookie("specialmessage", "read", { path: "/" });
	});
}();

OFFSET.referralSelect = function() {
	$("#referralSourceSelect").change(function() {
		var theText = $(this).find(":selected").attr("data-message");
		$("#referraltext").removeClass("d-none").attr("placeholder",theText).removeAttr("disabled");
	});
}();

OFFSET.dropdownMenu = function() {
	$(".main-header .header-nav-listing").on("mouseenter", e => {
		const $target = $(e.target).closest(".header-nav-listing");
		const $toggle = $(e.target).closest(".header-nav-listing.dropdown-active");
		if (!$target.hasClass("show")) {
			$(".header-nav-listing.dropdown-active").dropdown("hide");
		}
		if ($toggle.length) {
			$toggle.dropdown("show");
		}
	});
	$(".header-nav-listing.dropdown-active").on("click", (e) => {
		const $target = $(e.target).closest(".header-nav-listing.dropdown-active");
		if ($target.attr("href") && $target.attr("href") !== "#") {
			window.location.href = $target.attr("href");
		}
	});
	const hiders = [".offset-brand-statement", "section", "main", "footer"];
	hiders.forEach(hider => {
		$(hider).on("mouseenter", () => {
			$(".header-nav-listing.dropdown-active").dropdown("hide");
		});
	});
	$(window).on("scroll", () => {
		$(".header-nav-listing.dropdown-active").dropdown("hide");
	})

}();

$.fn.typeWriter = function(options) {
	// Default settings
	const settings = $.extend({
		speed: 50,
		deleteSpeed: 50,
		pauseBetween: 50,
		pauseBeforeDelete: 2000
	}, options);

	return this.each(function() {
		const $element = $(this);

		const words = [];
		for (i = 1; i < 10; i++) {
			if ($element.data(`statement-${i}`)) {
				words.push($element.data(`statement-${i}`));
			}
		}
		let wordIndex = 0;
		let text = "";
		let isDeleting = false;

		function type() {
			// Current word
			const current = words[wordIndex];

			// Typing or deleting
			if (isDeleting) {
				// Remove a character
				text = "";
			} else {
				// Add a character
				text = current.substring(0, text.length + 1);
			}

			// Update text
			$element.find(".typing-text").text(text);

			// Determine typing speed
			let typeSpeed = settings.speed;

			// If deleting, use delete speed
			if (isDeleting) {
				typeSpeed = settings.deleteSpeed;
			}

			// If word is complete
			if (!isDeleting && text === current) {
				// Pause before deleting
				typeSpeed = settings.pauseBeforeDelete;
				isDeleting = true;
			}
			// If word is deleted
			else if (isDeleting && text === "") {
				// Move to next word
				isDeleting = false;
				wordIndex = (wordIndex + 1) % words.length;

				// Pause before typing next word
				typeSpeed = settings.pauseBetween;
			}

			// Schedule next iteration
			setTimeout(type, typeSpeed);
		}

		// Start typing
		type();
	});
};

OFFSET.footerTypeWriter = function() {
	// Auto-initialize typing elements
	$(".js-brand-statement-logo-ext").typeWriter();
}();

OFFSET.init = function() {
	$("body").headroom({ offset: 20 });

	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	let vh = window.innerHeight * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty("--vh", `${vh}px`);

	if( /Android|webOS|iPad|iPhone|Opera Mini/i.test(navigator.userAgent) ) {
		$("body").addClass("mobile-device");
		$(".home-intro").addClass("mobile-device");
	}


}();

OFFSET.homeMeasure = function() {
	var logoHeight = $(".home-intro-bottom").outerHeight();
	$(".home-intro").css("padding-bottom",logoHeight);
};
// OFFSET.homeMeasure();
$(window).on("load resize", function() {
	OFFSET.homeMeasure();
});


OFFSET.accordionHack = function() {
	$('[data-toggle="collapse"]').not(".nav-collapser").on("click",function(e){
		if ( $(this).parents("#optionspanes").find(".collapse.show") ){
			var idx = $(this).index('[data-toggle="collapse"]');
			if (idx == $(".collapse.show").index(".collapse")) {
				// prevent collapse
				// e.stopPropagation();
			}
		}
	});
}();

OFFSET.homepageTextSwapper = function() {

	//Top Swap
	var numberofWords = $(".changer span").length;
	var timeInterval = $(".changer").attr("data-time-interval");
	//console.log(numberofWords);
	function changeText() {
		setTimeout(function(){
			$(".changer span").removeClass("shown");
			$(".changer span:nth-child(2)").addClass("shown");
		}, timeInterval);
		setTimeout(function(){
			$(".changer span").removeClass("shown");
			$(".changer span:nth-child(3)").addClass("shown");
		}, timeInterval*2);
		setTimeout(function(){
			$(".changer span").removeClass("shown");
			$(".changer span:nth-child(4)").addClass("shown");
		}, timeInterval*3);
		if(numberofWords == 4) {
			setTimeout(function(){
				$(".changer span").removeClass("shown");
				$(".changer span:first-child").addClass("shown");
			}, timeInterval*4);
		}
		if(numberofWords == 5) {
			setTimeout(function(){
				$(".changer span").removeClass("shown");
				$(".changer span:nth-child(5)").addClass("shown");
			}, timeInterval*4);
			setTimeout(function(){
				$(".changer span").removeClass("shown");
				$(".changer span:first-child").addClass("shown");
			}, timeInterval*5);
		}
		if(numberofWords == 6) {
			setTimeout(function(){
				$(".changer span").removeClass("shown");
				$(".changer span:nth-child(5)").addClass("shown");
			}, timeInterval*4);
			setTimeout(function(){
				$(".changer span").removeClass("shown");
				$(".changer span:nth-child(6)").addClass("shown");
			}, timeInterval*5);
			setTimeout(function(){
				$(".changer span").removeClass("shown");
				$(".changer span:first-child").addClass("shown");
			}, timeInterval*6);
		}
	}
	changeText();
	setInterval(function(){
		changeText();
	}, timeInterval*numberofWords);

	var numberofWords2 = $(".changer2 span").length;
	var timeInterval2 = $(".changer2").attr("data-time-interval");

	//Bottom Swap
	function changeText2() {
		setTimeout(function(){
			$(".changer2 span").removeClass("shown");
			$(".changer2 span:nth-child(2)").addClass("shown");
		}, timeInterval2);
		setTimeout(function(){
			$(".changer2 span").removeClass("shown");
			$(".changer2 span:nth-child(3)").addClass("shown");
		}, timeInterval2*2);
		setTimeout(function(){
			$(".changer2 span").removeClass("shown");
			$(".changer2 span:nth-child(4)").addClass("shown");
		}, timeInterval2*3);
		if(numberofWords2 == 4) {
			setTimeout(function(){
				$(".changer2 span").removeClass("shown");
				$(".changer2 span:first-child").addClass("shown");
			}, timeInterval2*4);
		}
		if(numberofWords2 == 5) {
			setTimeout(function(){
				$(".changer2 span").removeClass("shown");
				$(".changer2 span:nth-child(5)").addClass("shown");
			}, timeInterval2*4);
			setTimeout(function(){
				$(".changer2 span").removeClass("shown");
				$(".changer2 span:first-child").addClass("shown");
			}, timeInterval2*5);
		}
		if(numberofWords2 == 6) {
			setTimeout(function(){
				$(".changer2 span").removeClass("shown");
				$(".changer2 span:nth-child(5)").addClass("shown");
			}, timeInterval2*4);
			setTimeout(function(){
				$(".changer2 span").removeClass("shown");
				$(".changer2 span:nth-child(6)").addClass("shown");
			}, timeInterval2*5);
			setTimeout(function(){
				$(".changer2 span").removeClass("shown");
				$(".changer2 span:first-child").addClass("shown");
			}, timeInterval2*6);
		}
	}
	changeText2();
	setInterval(function(){
		changeText2();
	}, timeInterval2*numberofWords2);

}();

OFFSET.hoverHack = function() {
	$(".dropdown").hover(function() {
		$(this).find(".dropdown-toggle").dropdown("toggle");
	}, function() {
		$(this).find(".dropdown-toggle").dropdown("hide");
	});
	$(".nav-primary").click(function() {
		var lelink = $(this).attr("href");
		$(".dropdown-toggle").dropdown("hide");
		window.location = lelink
	});
}();

OFFSET.slideHeight = function() {
	$(".carousel").each(function(){
		var items = $(".carousel-item", this);
		var windowWidth = $(window).width();
		items.css("min-height", 0);
		var maxHeight = Math.max.apply(null,
			items.map(function(){
				return $(this).outerHeight()}).get() );
		items.css("min-height", `${maxHeight}px`);
		if (windowWidth >= 992) {
			$(".inset-quote").css("min-height", `${maxHeight}px`);
		} else {
			$(".inset-quote").css("min-height","1px");
		}
	});
};

OFFSET.slideCount = function() {
	$(".carousel").each(function(){
		var totalItems = $(this).find(".carousel-item").length;
		$(".total-slides").html(totalItems);
	});
	$(".carousel").on("slid.bs.carousel", function () {
		var currentIndex = $(this).find(".carousel-item.active").index() + 1;
		$(".current-slide").html(currentIndex);
	});
};
OFFSET.statementMeasure = function() {
	var windowWidth = $(window).width();
	var theWidth = $(".site-header .desktop-nav .nav-links").outerWidth();
	//console.log(theWidth);
	//console.log(windowWidth);
	if (windowWidth >= 1200) {
		$(".home-action-links").css("width",theWidth-14);
	} else {
		$(".home-action-links").css("width","auto");
	}
};


OFFSET.slideCount();
$(window).on("load resize",function() {
	OFFSET.statementMeasure();
});

OFFSET.ajaxModal = function() {
	$(document).on("click","a.case-study-modal",function() {
		var theLink = $(this).attr("href");
		var windowWidth = $(window).width();
		$("#caseStudyModal").modal();
		if (windowWidth >= 768) {
			$("#caseStudyModal .modal-load-area").load(theLink+"?pagetype=modal");
			$("#caseStudyModal").on("shown.bs.modal", function () {
				$(".modal-carousel-holder").addClass("loaded");
				$(document).ajaxStop(function() {
					OFFSET.slideHeight();
					OFFSET.slideCount();
					$(".modal-carousel-holder").addClass("loaded");
				});
			});
		} else {
			$("#caseStudyModal .modal-load-area").load(theLink+"?pagetype=mobilemodal");
			$("#caseStudyModal").on("shown.bs.modal", function () {
				$(".modal-carousel-holder").addClass("loaded");
				$(document).ajaxStop(function() {
					$(".modal-carousel-holder").addClass("loaded");
				});
			});
		}
		$("#caseStudyModal").on("hidden.bs.modal", function () {
			$("#caseStudyModal .modal-load-area").html("");
		});
		return false;
	});
}();

OFFSET.mobileNav = function() {
	$(document).on("click","#toggleNav",function() {
		if($(this).hasClass("expanded")) {
			$(this).removeClass("expanded");
			$(".mobile-nav").slideUp(500).removeClass("open");
			$(".hero-box").removeClass("navopen");
			$(".home-intro").removeClass("navopen");
			$(".logo-tagline").removeClass("navopen");
			$("main a").removeAttr("tab-index").removeAttr("aria-hidden");
		} else {
			$(this).addClass("expanded");
			$(".hero-box").addClass("navopen");
			$(".mobile-nav").slideDown(500).addClass("open");
			$(".hero-box").addClass("navopen");
			$(".home-intro").addClass("navopen");
			$(".logo-tagline").addClass("navopen");
			$("main a").attr("tab-index","-1").attr("aria-hidden","true");
		}
		return false;
	});
}();

OFFSET.showFilters = function() {
	$(document).on("click",".show-filters",function() {
		$(".filter-show").fadeIn();
		return false;
	});
	$(document).on("click","#closeFilters",function() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$(".filter-show").fadeOut();
		}
		return false;
	});
	$(window).resize(function() {
		var windowWidth = $(window).width();
		if (windowWidth > 768) {
			$(".filter-show").fadeIn();
		} else {
			$(".filter-show").fadeOut();
		}
	});
}();

OFFSET.closeEverything = function() {
	$(document).keyup(function(e) {
		if (e.keyCode === 27) {
			$("#toggleNav").removeClass("expanded");
			$(".mobile-nav").slideUp(500).removeClass("open");
			$(".hero-box").removeClass("navopen");
			$(".home-intro").removeClass("navopen");
			$(".logo-tagline").removeClass("navopen");
			$("main a").removeAttr("tab-index").removeAttr("aria-hidden");
			var windowWidth = $(window).width();
			if (windowWidth < 768) {
				$(".filter-show").fadeOut();
			}
		}
	});
}();

OFFSET.widgetPusher = function() {
	if ($("body").hasClass("page-template-page-insights-paginated")) {
		$(document).ajaxStop(function() {
			var windowWidth = $(window).width();
			var toPush = $(".alm-paging-content article:nth-child(2)").position();
			if (windowWidth > 767.98) {
				$(".sidebar-location-sidebar-thinking-landing").css("padding-top",toPush.top).addClass("seen");
			}
		});
	}
	$(window).resize(function() {
		var windowWidth = $(window).width();
		var toPush = $(".alm-paging-content article:nth-child(2)").position();
		if ($("body").hasClass("page-template-page-insights-paginated")) {
			if (windowWidth < 767.98) {
				$(".sidebar-location-sidebar-thinking-landing").css("padding-top","0");
			} else {
				$(".sidebar-location-sidebar-thinking-landing").css("padding-top",toPush.top);
			}
		}
	});
};

OFFSET.scrollTo = (function() {
	$(document).on("click", ".scrollto", function(e) {
		if (!$(this).hasClass("killscroll")) {
			if (
				location.pathname.replace(/^\//, "") ==
				this.pathname.replace(/^\//, "") &&
				location.hostname == this.hostname
			) {
				var target = $(this.hash);
				var scrollOffset = $(this).attr("data-offset");
				target = target.length
					? target
					: $("[name=" + this.hash.slice(1) + "]");
				if (scrollOffset > 0) {
					var theScroll = target.offset().top - scrollOffset;
				} else {
					var theScroll = target.offset().top;
				}
				if (target.length) {
					$("html,body").animate(
						{
							scrollTop: theScroll
						},
						1000
					);
				}
			}
			return false;
		}
	});
})();

OFFSET.slickCarousel = function() {
	$(".thinking-carousel").slick({
		dots:false,
		infinite:false,
		responsive:true,
		slidesToShow:1,
		slidesToScroll:1,
		centerMode:true,
		variableWidth:true,
		fade:false,
		accessibility:true,
		adaptiveHeight:false,
		focusOnSelect:true,
		TouchThreshold:1,
		speed:600
	});
	$(".post-carousel").slick({
		arrows:false,
		dots:false,
		infinite:false,
		responsive:true,
		slidesToShow:1,
		slidesToScroll:1,
		centerMode:true,
		variableWidth:true,
		fade:false,
		accessibility:true,
		adaptiveHeight:false,
		focusOnSelect:true,
		TouchThreshold:1,
		speed:600,
	});
	var currentSlide = $(".thinking-carousel").slick("slickCurrentSlide");
	$(".slick-prev").toggle(currentSlide != 0);
	$(".slick-next").toggle(currentSlide != 2);
	$(".thinking-carousel").one("afterChange", function() {
		$(".slick-prev,.slick-next").show();
	});
	var KurrentSlide = $(".post-carousel").slick("slickCurrentSlide");
	$(".slick-prev").toggle(KurrentSlide != 0);
	$(".slick-next").toggle(KurrentSlide != 2);
	$(".post-carousel").one("afterChange", function() {
		$(".slick-prev,.slick-next").show();
	});
	$(".slick-current").addClass("zoomy");
	$(".post-carousel").on("afterChange", function(event, slick, currentSlide, nextSlide){
		$(".slick-slide").removeClass("zoomy");
		$(".slick-current").addClass("zoomy");
	});
	$(".thinking-carousel").on("afterChange", function(event, slick, currentSlide, nextSlide){
		$(".slick-slide").removeClass("zoomy");
		$(".slick-current").addClass("zoomy");
	});
	$(".slick-slide:not(.slick-current) a").on("click", function(e) {
		e.preventDefault();
	});
}();

OFFSET.autoPlayVideo = function() {
	$(window).on('load scroll', function() {
		$("video").each((i, video) => {
			if($(video).hasClass("noauto")) {
				return;
			} else {
				$(video).attr("playsinline", true);
				video.playsinline = true;
				$(video).attr("muted", true);
				video.muted = true;
				if ($(video).is(":in-viewport(180)")) {
					$(video).attr("autoplay", true);
					const playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise.catch(error => {
							console.log("Auto-play was prevented:", error);
							// Could show play button or handle gracefully
						});
					}
				}
			}
		});
	});
}();

OFFSET.anchorHack = function() {
	$(".dropdown a, .subnav a").click(function(e) {
		var target = $(this.hash);
		target = target.length ? target : $("[name=" + this.hash.slice(1) +"]");
		var windowWidth = $(window).width();
		if (target.length) {
			$("html,body").animate({
				scrollTop: target.offset().top - 40
			}, 1000);
		}

	});
	if (location.hash){
		var id = $(location.hash);
	}
	$(document).on("load", function() {
		if (location.hash){
			var id = $(location.hash);
			$("html,body").animate({scrollTop: id.offset().top - 40}, "linear")
		};
	});
	$(".scrolltooptions").click(function() {
		var target = $("#theoptions");
		var theScroll = target.offset().top;
		if (target.length) {
			$("html,body").animate(
				{
					scrollTop: theScroll
				},
				1000
			);
		}
	});
}();

OFFSET.paginationHack = function() {
	$(document).on("click",".alm-paging a",function() {
		$("html,body").animate({
			scrollTop: 0
		}, 300);
	});
}();

OFFSET.flipper = function() {
	$(".logo-flipper-content").each((i, flipper) => {
		let flipperKids = 0;
		for (let i = 1; i < 5; i++) {
			if ($(flipper).find(`.fb${i}`).length) {
				// console.log($(flipper).find(`.fb${i}`), $(flipper).find(`.fb${i}`).find("img"))
				if ($(flipper).find(`.fb${i}`).find("img").length > flipperKids) {
					flipperKids = $(flipper).find(`.fb${i}`).find("img").length;
				}
			}
		}
		const firstFlipWait = flipperKids < 3 ? 5000 : 3333;
		if (flipperKids > 1) {
			setTimeout(() => {
				for (let i = 1; i < 5; i++) {
					if ($(flipper).find(`.fb${i}`).length) {
						setTimeout(() => {
							$(flipper).find(`.fb${i}`).addClass("go");
						}, i === 1 ? 0 : i * 100);
					}
				}
			}, firstFlipWait);
		}
		if (flipperKids > 2) {
			setTimeout(() => {
				for (let i = 1; i < 5; i++) {
					if ($(flipper).find(`.fb${i}`).length) {
						setTimeout(() => {
							$(flipper).find(`.fb${i}`).addClass("more");
						}, i === 1 ? 0 : i * 100);
					}
				}
			}, 6666);
		}
		if (flipperKids > 1) {
			setTimeout(() => {
				for (let i = 1; i < 5; i++) {
					if ($(flipper).find(`.fb${i}`).length) {
						setTimeout(() => {
							$(flipper).find(`.fb${i}`).removeClass("more").removeClass("go");
							;
						}, i === 1 ? 0 : i * 100);
					}
				}
			}, 9999);
		}
	});
};
OFFSET.flipper();
setInterval(function () {
	OFFSET.flipper();
}, 10001);


OFFSET.ajaxFormTest = function() {
	$("#signUpTestForm").submit(function(event) {
		event.preventDefault();
		var form = $(this);
		var actionUrl = "https://offsetcrm.developmentsite.io/signup/create-account/";
		$.ajax({
			type: "POST",
			url: actionUrl,
			dataType : "json",
			data: form.serialize(),
			success: function(data) {
				if (data.status == "success") {
					$("#formMessaging").html("Thank you for your submission!").removeClass("d-none").removeAttr("style");
					form.hide();
				} else {
					$("#formMessaging").html("Looks like you are already on our list, thank you!").removeClass("d-none").css("color","red");
				}
				return;
			},
			error: function (data) {
				$("#formMessaging").html("An error has occurred").removeClass("d-none").css("color","red");
				return;
			}
		});
		return false;
	});
}();

OFFSET.rolePicker = function() {
	if($("body").hasClass("page-template-page-work")) {
		if($(".category-featured").length) {
			$(".person-filter").addClass("d-none");
			$(".category-featured").removeClass("d-none");
			$(".feat").removeClass("d-none").addClass("selected");
			$(".show-all").removeClass("selected");
		}
	}
	$(".filter-bar a").click(function() {
		var target = $(this.hash);
		target = target.length ? target : $("[name=" + this.hash.slice(1) +"]");
		var windowWidth = $(window).width();
		if (target.length) {
			$("html,body").animate({
				scrollTop: target.offset().top - 100
			}, 1000);
		}
		$(".filter-bar a.selected").removeClass("selected");
		$(this).addClass("selected");
		if ($(this).hasClass("show-all")) {
			$(".person-filter").removeClass("d-none");
		} else {
			var theDept = $(this).attr("data-department");
			$(".person-filter").addClass("d-none");
			$(theDept).removeClass("d-none");
		}
		return false;
	});
}();

OFFSET.sticky = function() {
	$(window).scroll(function() {
		if ($(".above-sticky").is(":in-viewport")) {
			$(".filter-bar").removeClass("stuck");
		} else {
			$(".filter-bar").addClass("stuck");
		}
	});
}();

OFFSET.navTabs = function() {
	const hash = window.location.hash;
	if (hash) {
		$(".filter-categories .nav-link").each((i, el) => {
			let dataTarget = $(el).data("target");
			const navHash = dataTarget.replace("nav-", "");
			if (([dataTarget, navHash]).includes(hash)) {
				$(el).tab('show');
				if ($(el).hasClass("nav-link-hidden")) {
					$(el).removeClass("nav-link-hidden");
					const separatorId = $(el).attr("id") + "-separator";
					$(`#${separatorId}`).removeClass("nav-separator-hidden");
				}
				$(window).on("load", function() {
					setTimeout(() => {
						const scrollOffset = $(el).attr("data-offset");
						dataTarget = $(dataTarget).length
							? $(dataTarget)
							: $("[name=" + hash.slice(1) + "]");
						let theScroll = dataTarget.offset().top;
						if (scrollOffset > 0) {
							theScroll = dataTarget.offset().top - scrollOffset;
						}
						if (dataTarget.length) {
							$(".filter-categories").addClass("sticky-cat");
							$(".filter-categories").addClass("sticky-cat-top");
							$("html,body").animate(
								{
									scrollTop: theScroll
								},
								500,
								() => {
									$(".filter-categories").addClass("sticky-cat");
									$(".filter-container").addClass("pt-3");
								}
							);
						}
					}, 100);
				})
			}
		});
	}
	$(".filter-categories .nav-link").each((i, el) => {
		$(el).on("click", function() {
			setTimeout(() => {
				$(".filter-categories").addClass("sticky-cat");
				$(".filter-categories").addClass("sticky-cat-top");
				$("body").removeClass("headroom--pinned");
				$("body").addClass("headroom--unpinned");
			}, 1000);
		});
	});
	$(".nav-listing-sub").on("click", function(e) {
		e.preventDefault();
		const target = $(e.target).closest(".nav-listing-sub");
		if (target.attr("href")) {
			const link = target.attr("href");
			location.href = link;
			$(".open-nav").trigger("click");
		}
	});
}();

OFFSET.categoriesEffects = function() {
	const category = ".filter-categories";
	const container = ".filter-container";
	if ($(category).length && $(container).length) {
		$(window).on('scroll load', e => {
			const positionFromTop = $(container).offset().top;
			const scrollTop = $(window).scrollTop();
			const positionInViewport = positionFromTop - scrollTop;
			if (OFFSET.isElementInViewport($(container))) {
				if ($(category).hasClass("sticky-cat")) {
					if (positionInViewport < 100) {
						$(category).addClass("sticky-cat-top");
					} else {
						$(category).removeClass("sticky-cat-top");
					}
				} else {
					if (positionInViewport < 0) {
						$(category).addClass("fixed-cat");
					} else {
						$(category).removeClass("fixed-cat");
					}
				}
			} else {
				$(category).removeClass("fixed-cat");
			}
		});
	}
}();

OFFSET.isElementInViewport = function($element) {
	const elementTop = $element.offset().top;
	const elementBottom = elementTop + $element.outerHeight();
	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
}


OFFSET.specialStickyTitle = function() {
	const workPost = $(".page-pages-work-post-special");
	const workSpecialSection = $(".work-special-section");
	// Recalculate the height of the sticky title
	const reheightTitle = function() {
		const h4Height = $(".special-sticky h4").outerHeight();
		const h1Height = $(".special-sticky h1").outerHeight();
		const adjustedHeight = h4Height + h1Height + 80;
		$(".special-sticky").css({top: `calc(100vh - ${adjustedHeight}px)`}, 200);
		$(".work-special-section").css({marginBottom: adjustedHeight});
	}
	// Reposition mask
	const figureHero = $(".work-hero-figure");
	const mask = $(".radial-gradient-lower-left");
	const repositionMask = function() {
		const windowHeight = $(window).height();
		const figureHeroHeight = figureHero.outerHeight();
		const scrollTop = $(window).scrollTop();
		const scrollBottom = scrollTop + windowHeight;
		if (figureHeroHeight < scrollBottom) {
			const diff = scrollBottom - figureHeroHeight;
			const opacity = Math.max(0, 1 - ((diff / figureHeroHeight) * .5));
			mask.css({
				bottom: diff,
				opacity: opacity
			});
		} else {
			mask.css({
				bottom: 0,
				opacity: 1
			});
		}
	};
	if (workPost.length && workSpecialSection.length) {
		$(window).on("load", function() {
			reheightTitle();
			repositionMask();
		});
		$(window).on("resize scroll", function(e) {
			repositionMask();
		});
		$(window).on("resize scroll", OFFSET.debounce(function() {
			if (OFFSET.isElementInViewport(workSpecialSection)) {
				reheightTitle();
			}
		}, 300));
	}
}();

OFFSET.setCarouselHeight = function() {
	const updateArrows = function(carousel) {
		const totalItems = $('.carousel-item', carousel).length; // Get the total number of items
		const currentIndex = $('.carousel-item.active', carousel).index(); // Get the current item index
		if (currentIndex === 0) { // Hide/show previous arrow
			$('.carousel-control-prev', carousel).hide();
		} else {
			$('.carousel-control-prev', carousel).show();
		}
		if (currentIndex === totalItems - 1) { // Hide/show next arrow
			$('.carousel-control-next', carousel).hide();
		} else {
			$('.carousel-control-next', carousel).show();
		}
	}
	const carouselHeightSetter = function($carousel) {
		let maxHeight = 0;
		const $items = $carousel.find('.carousel-item'); // Get all carousel items
		$items.css({ // Temporarily make all items visible but hidden
			display: 'block',
			visibility: 'hidden',
			position: 'absolute'
		});
		$items.each(function () { // Measure each item
			const height = $(this).outerHeight();
			maxHeight = Math.max(maxHeight, height);
		});
		$items.css({// Restore original styles
			display: '',
			visibility: '',
			position: ''
		});
		$carousel.find('.carousel-inner').height(maxHeight); // Set container height
	}
	$(document).ready(function() {
		$('.quote-carousel').each((i, carousel) => {
			updateArrows($(carousel));
			$(carousel).on('slid.bs.carousel', function() {
				updateArrows($(carousel));
			});
			carouselHeightSetter($(carousel));
		})
	});

// Also call when images load since they might affect height
	$('#myCarousel img').on('load', function() {
		$('.quote-carousel').each((i, carousel) => {
			carouselHeightSetter($(carousel));
		})
	});

// And on window resize
	$(window).on('resize', OFFSET.debounce(function() {
		$('.quote-carousel').each((i, carousel) => {
			carouselHeightSetter($(carousel));
		})
	}, 250));

	// Initial state - hide prev arrow if on first slide

	// Update arrows on slide change


}();

OFFSET.checker = function() {
	// $(".quote-carousel").find(".the-quote").each((i, el) => {
	// 	console.log(el, OFFSET.getHiddenHeight($(el)));
	// })
}();
OFFSET.addDash = function() {
	$(".add-dash").each((i, el) => {
		if ($(el).text().length && $(el).text().indexOf("-") !== 0 && $(el).text().indexOf("–") !== 0) {
			const elText = $(el).text();
			$(el).text(`– ${elText}`);
		}
	});
}();
OFFSET.collapseTextChange = function() {
	const collapseTargetButton = $(".collapse-text-change-button");
	const collapseTargetCollapseText = collapseTargetButton.data('collapse-text');
	const collapseTargetExpandedText = collapseTargetButton.data('expanded-text');
	const collapseTarget = collapseTargetButton.data('target');
	collapseTargetButton.on('click', function(e) {
		e.preventDefault();
		$(collapseTarget).collapse('toggle');
	})
	$(collapseTarget).on("show.bs.collapse hide.bs.collapse", OFFSET.debounce(function(e) {
		if (e.type === "show") {
			collapseTargetButton.text(collapseTargetExpandedText);
		} else {
			collapseTargetButton.text(collapseTargetCollapseText);
		}
	}, 500));
}();
// OFFSET.logosCollapse = function() {
// 	const collapseMoreLogosClass = "more-logos-collapse";
// 	const collapseMoreLogos = $(`.${collapseMoreLogosClass}-button`);
// 	const collapseMoreLogosButton = collapseMoreLogos.find("button");
// 	const collapseMoreLogosSwap = collapseMoreLogosButton.data("target-swap");
// 	const collapseMoreLogosOriginal = collapseMoreLogosButton.data("target-original");
// 	$(window).on('load resize', OFFSET.debounce(function() {
// 		if ($(window).width() < 576) {
// 			collapseMoreLogosButton.attr("data-target", collapseMoreLogosSwap)
// 		} else {
// 			collapseMoreLogosButton.attr("data-target", collapseMoreLogosOriginal);
// 		}
// 	}));
// }()
OFFSET.relatedPosts = function() {
	const relatedPostsContainer = $(".related-posts-container");
	if (relatedPostsContainer.length) {
		$(window).on("load resize", function() {
			if ($(window).width() >= 992) {
				const containerHeight = $(".content-group-parent").height();
				relatedPostsContainer.css({"padding-top": (containerHeight * .8) - 250});
			} else {
				relatedPostsContainer.css({"padding-top": 0});
			}

		});
	}
}();

OFFSET.addBylineDash = function() {
	$(".the-author").each((i, author) => {
		if (!(/^.{0,3}[-–—]/).test($(author).text().trim())) {
			if ($(author).find("p").length) {
				$(author).find("p").each((j, p) => {
					if (j > 0) return;
					if (!(/^[-–—]/).test($(p).text().trim())) {
						$(p).prepend("— ");
					}
				});
			}
		}
	})
}();